"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHttpRequest = void 0;
const assert_1 = require("@brillout/assert");
// @ts-ignore
const json_s_1 = require("@brillout/json-s");
// @ts-ignore
const fetch = require("@brillout/fetch");
async function makeHttpRequest(url, body, endpointName) {
    const makeRequest = addHandli(() => fetch(url, {
        /* Also enable `DEBUG_CACHE` flag on server-side.
            method: 'GET',
            /*/
        method: "POST",
        body,
        //*/
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
        },
    }));
    let response;
    let connectionError;
    try {
        response = await makeRequest();
    }
    catch (err) {
        connectionError = err;
    }
    if (connectionError) {
        throw Object.assign(new Error("No Server Connection"), {
            isConnectionError: true,
            isCodeError: false,
        });
    }
    const responseBody = await response.text();
    const contentType = response.headers.get("content-type");
    const isOk = response.ok;
    assert_1.assert([true, false].includes(isOk));
    const value = 
    // TODO use mime type instead
    contentType.includes("application/json")
        ? json_s_1.parse(responseBody)
        : responseBody;
    const statusCode = response.status;
    if (isOk) {
        assert_1.assert(statusCode === 200);
        return value;
    }
    // The Wildcard client issued a malformatted request.
    assert_1.assert(statusCode !== 400);
    // Status codes ever returned by the Wilcard server:
    //  - 200
    //  - 400
    //  - 404
    //  - 500
    assert_1.assert([500, 404].includes(statusCode));
    const codeErrorText = statusCode === 404
        ? `Endpoint \`${endpointName}\` does not exist.`
        : `Endpoint function \`${endpointName}\` threw an error.`;
    const codeError = Object.assign(new Error(codeErrorText), {
        isConnectionError: false,
        isCodeError: true,
    });
    throw codeError;
}
exports.makeHttpRequest = makeHttpRequest;
function addHandli(fetcher) {
    return () => {
        if (typeof window !== "undefined" &&
            window.handli &&
            window.handli.constructor === Function) {
            return window.handli(fetcher);
        }
        return fetcher();
    };
}
//# sourceMappingURL=makeHttpRequest.js.map